import { render, staticRenderFns } from "./GroupEditModal.vue?vue&type=template&id=15de604e&scoped=true&"
import script from "./GroupEditModal.vue?vue&type=script&lang=js&"
export * from "./GroupEditModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupEditModal.vue?vue&type=style&index=0&id=15de604e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de604e",
  null
  
)

export default component.exports